import React, { Fragment } from 'react';
import {
  TextField,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  DialogActions,
  Typography,
  Stack
} from '@mui/material';

import { contactUs } from '../services/contact-us.service';
import { SubmitButton } from './submit-button.component';

export function ContactForm(): JSX.Element {
  const [message, setmessage] = React.useState('');
  const [showModal, setShowModal] = React.useState(false);

  return (
    <Fragment>
      <Link underline='none' sx={{ color: 'white' }} onClick={(): void => setShowModal(true)}>
        Contact Us
      </Link>
      <Dialog open={showModal} onClose={(): void => setShowModal(false)}>
        <DialogTitle>Contact Us</DialogTitle>
        <DialogContent>
          <Box mt={1} minWidth={500}>
            <Typography>
              We are here to support your sales and marketing goals. We are happy to answer any
              questions you might have.
            </Typography>
            <TextField
              fullWidth
              label='Message:'
              multiline
              variant='outlined'
              name='message'
              rows={4}
              sx={{
                mt: 1,
                mb: 1
              }}
              onChange={(event): void => {
                setmessage(event.target.value);
              }}
            />
          </Box>
          <Stack>
            <Typography>
              Help Email: <b>mlsteam@homesusa.com</b>
            </Typography>
            <Typography>
              Phone: <b>(469) 916-5493</b>
            </Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <SubmitButton
            onClick={async (): Promise<void> => {
              if (message == null || message === '') {
                return;
              }
              await contactUs(message);
              setmessage('');
              setShowModal(false);
            }}
          >
            Send
          </SubmitButton>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
